import AdminLists from './adminLists/'
import Access from './access/'
import Role from './role.vue'
import User from './user/'
import Personal from './personal.vue'
import ThirdApp from './thirdApp.vue'
import Config from './config.vue'

export default {
	AdminLists,
	Role,
	User,
	Access,
	Personal,
	Config,
	ThirdApp
}



// WEBPACK FOOTER //
// ./src/views/user/index.js